import React, { type FC } from 'react';

interface ViewHeaderProps {
  title: string;
}

const ViewHeader: FC<ViewHeaderProps> = ({ title }) => {
  return (
    <div id={`view-header-${title}`} className='flex whitespace-nowrap items-center py-3'>
      <div>
        <p id={`view-header-title-${title}`} className='uppercase text-2xl text-bold tracking-wide text-indigo-500'>{title}</p>
      </div>
      <div className='w-full h-fit ml-5'>
        <hr />
      </div>
    </div>
  );
};

export default ViewHeader;
